import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";

// Types
import { ITag } from "@/models/tags";
import { IState } from "@/store";
import { IFilter } from "@/models/tables";
import { TranslateResult } from "vue-i18n";
import { UUID } from "@/data/enums";
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      tags(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.TAGS,
          scope: this.scope
        });
      }
    })
  }
})
export default class TagsMixin extends Mixins(RequestPromises) {
  // Getters
  public tags!: ITag[];

  // Props
  @Prop({ default: UUID.ORG })
  public tagsBrandId!: IBrand["id"];

  public tagFilter = {
    operator: FilterOperators.ANY,
    type: FilterTypes.TAG,
    options: this.tags
  } as IFilter;

  public getTags(ignoreStored = false, withStagedImports = false) {
    return this.$store.dispatch(`data/${DataModules.TAGS}/list`, {
      params: this.$_.merge(
        { limit: 0, offset: 0, order: "-name" },
        withStagedImports ? { with_staged_imports: 1 } : {},
        this.tagsBrandId !== UUID.ORG
          ? { "filter[brand_id]": this.tagsBrandId }
          : {}
      ),
      vm: this,
      ignoreStored
    });
  }

  public createTagFilter(
    key: string,
    label: string | TranslateResult,
    group: string
  ): IFilter {
    return this.$_.merge({}, this.tagFilter, {
      key,
      label,
      group,
      options: this.tags
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.TAGS,
      vm: this
    });
  }
}
